import type { ReactNode } from 'react';
import { CerbosProvider } from '@cerbos/react';

import { CerbosClient } from './cerbos-client';
import type { Principal } from './get-principal';

interface AuthzProviderProps {
  principal: Principal;
  // we use ReactNode instead of PropsWithChildren to make children prop required
  children: ReactNode;
}

export const AuthzProvider = ({ principal, children }: AuthzProviderProps) => {
  return (
    <CerbosProvider client={CerbosClient} principal={principal}>
      {children}
    </CerbosProvider>
  );
};

export default AuthzProvider;

// Export additional utilities
export { CerbosClient } from './cerbos-client';
export { getPrincipal, getPrincipalKey } from './get-principal';
export type { Principal } from './get-principal';
